// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"54254038","71":"ece9627a","84":"75445eaf","126":"49445e3c","453":"649571a3","484":"c61a682f","627":"67b76a05","642":"855bc78f","740":"55019a1b","856":"60377412","895":"a9ea2369","907":"0dc9bb23","978":"9e6d5a45"}[chunkId] + ".chunk.js";
};